import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './plugins/element-ui/index';
import './plugins/polyv-ui/index';
import './assets/styles/index.scss';
import { groupRequest } from '@/request/index';
import { ynToBool } from '@polyv/utils/src/boolean';
import { DatePicker } from '@polyv/polyv-ui';
import { commafy, isNoAssignment, formatDuration } from '@/utils/utils';
Vue.config.productionTip = false;
Vue.prototype.$request = groupRequest;

console.info('%c集团账号 Build Time%c ' +
  new Date().toString(),
'color: white; background: #0070ed; font-size: 12px; padding: 1px 2px',
'');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
Vue.mixin({
  filters: {
    toLocale(value) {
      if (isNoAssignment(value)) return '-';
      return commafy(value);
    },

    decimalFormat(value, decimal = 2) {
      if (isNoAssignment(value)) return '-';
      return Number(value).toFixed(decimal);
    },
    ynToEnable(value = 'N') {
      return ynToBool(value) ? '已开通' : '未开通';
    },
    formatBytesToGb(bytes) {
      if (!bytes) return '0 G';

      const k = 1024;
      const isPositive = bytes > 0;
      const absByte = Math.abs(bytes);
      const formatedData = parseFloat((absByte / Math.pow(k, 3)).toFixed(2)) + ' G';
      return isPositive ? formatedData : `-${formatedData}`;
    },

    vodUnit(value) {
      if (isNoAssignment(value)) return '-';
      const tempValue = value;
      return value >= 1024 ? `${(tempValue / 1024).toFixed(2)} T` : `${value}G`;
    },
    formatDate(date, format) {
      if (typeof date === 'string') {
        return date;
      }
      if (!date) {
        return '-';
      }
      if (date === '-' || date === '--') {
        return date;
      }
      format || (format = 'yyyy-MM-dd HH:mm:ss');
      return DatePicker.formatDate(new Date(date), format);
    },
    formatDuration,
  },
  methods: {
    ynToBool,
    boolToYn(bool) {
      return bool === true ? 'Y' : 'N';
    },
  }
});
